export default {"src":"/_next/static/media/blackTick.c5d9e162.svg","height":5,"width":7,"blurWidth":0,"blurHeight":0};